/**
 * Module dependencies.
 */

import { Squash as Hamburger } from 'hamburger-react';
import { HamburgerWrapper, NavBarMenu } from './navbar-menu.style';
import { JSX, forwardRef, useEffect } from 'react';
import { Language } from 'types/language';
import { Link } from 'components/atoms/link/link';
import { MenuItem } from 'components/atoms/menu-item/menu-item';
import { pageComponents } from 'constants/page-components';
import { useBreakpoints } from 'components/hooks/use-breakpoints';
import { useMenuContext } from 'components/providers/menu-provider/menu-provider';
import { useTranslation } from 'next-i18next';

/**
 * `Props` type.
 */

type Props = {
  languages: Language[];
};

/**
 *  `NavbarMenuComponent` component.
 */

function NavbarMenuComponent({ languages }: Props, ref): JSX.Element {
  const [translate] = useTranslation();
  const { breakpoint } = useBreakpoints();
  const { isMenuOpen, setIsMenuOpen, setLanguages } = useMenuContext();

  useEffect(() => {
    setLanguages?.(languages);
  }, [languages, setLanguages]);

  return (
    <div ref={ref}>
      {['mobile', 'mobileLarge', 'tablet'].includes(breakpoint) && (
        <HamburgerWrapper>
          <Hamburger size={20} toggle={setIsMenuOpen} toggled={isMenuOpen} />
        </HamburgerWrapper>
      )}

      {!['mobile', 'mobileLarge', 'tablet'].includes(breakpoint) && (
        <NavBarMenu className={isMenuOpen ? 'open' : ''}>
          {Object.keys(pageComponents).map((key) => (
            <Link href={pageComponents[key]} key={key}>
              <MenuItem>{translate(`links.${key}`)}</MenuItem>
            </Link>
          ))}
        </NavBarMenu>
      )}
    </div>
  );
}

/**
 * Export ``.
 */

export const NavbarMenu = forwardRef(NavbarMenuComponent);
